<template>
  <q-page style="height: 100vh">
    <q-img
      class="bg-accent"
      style="height: 100vh; position: absolute; width: 100vw"
    >
    </q-img>
    <div class="row" align="center" justify="center">
      <div class="col">
        <q-card class="loginCard fixed-center">
          <q-card-section class="">
            <div class="row">
              <div class="col-12">
                <div style="max-width: 280px; max-height: 90%">
                  <!-- <q-img
                    src="/statics/Logo.png"
                    spinner-color="white"
                    :ratio="2 / 1"
                    contain
                  /> -->
                  <h3 class="loginHeader">{{ siteData.name }}</h3>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12">
                <q-btn
                  block
                  color="primary"
                  dark
                  class="full-width"
                  @click="login()"
                  >Login / Signup</q-btn
                >
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import { auth } from "@/firebase.js";

  export default {
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteData: "settings/siteData",
      }),
    },
    data: () => ({}),
    watch: {
      $auth: function () {},
    },
    mounted() {},
    methods: {
      // Log the user in
      login() {
        this.$auth.loginWithPopup();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .loginHeader {
    font-weight: 500 !important;
    color: $accent;
  }
</style>

<style>
  .loginCard {
    max-width: 600px;
    width: 90vw;
  }

  .google-signin-button {
    color: white;
    background-color: red;
    height: 50px;
    font-size: 16px;
    border-radius: 10px;
    padding: 10px 20px 25px 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
</style>
